import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PreFilter from "../../../../components/BuilderComponents/PreFilters/PreFilter";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAxiosContext } from "../../../../context/AxiosContext";
import { useTableContext } from "../../../../context/TableContext";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import BlockTiles from "../../ChartRenderer/BlockTiles";
import DetailsviewElementsBar from "../../DetailsViewRenderer/Desktop/DetailsviewElementsBar";
import DetailviewLayoutEditor from "../../DetailsViewRenderer/Desktop/DetailviewLayoutEditor";
import EditActions from "../Desktop/RecordsViewEdit/EditActions";
import { EditGeneralData, EditRvStyles, MobileFilters } from "./MobileRecordEditSection";
import "./MobileRecordsview.css";
import MobileRVPageActionsHandler from "./MobileRVPageActionsHandler";

const MobileRenderer = () => {
  const { getTableTypeData } = useTableContext();
  const tableRef = useRef();
  const navigate = useNavigate();
  const { handleError } = useAxiosContext();
  const [activeTab, setActiveTab] = useState(null);

  const { recordsviewLayout, setSelectedAppBlock, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();
  const [dragFromOutside, setDragFromOutside] = useState(false);
  const fetchCurrentSmData = async () => {
    try {
      const { tableObject } = await getTableTypeData(
        applicationBlockData.table_type,
        applicationBlockData.config.layout.table_id
      );
      tableRef.current = { ...tableObject };
    } catch (error) {
      handleError(error);
      navigate("../");
      setSelectedAppBlock({ id: "", name: "", parentData: "", table_id: "", activity_id: "" });
    }
  };

  const settingTiles = (data) => {
    const copyObj = { ...recordsviewLayout };
    copyObj.tiles = data;
    setRecordsviewLayout(copyObj);
  };

  const settingActions = (data) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    newObj.multi_select_custom_actions = data;
    setRecordsviewLayout(newObj);
  };

  const callbackFunctionOfOwnerAnePreFilter = (value, data) => {
    const newLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    newLayout[value] = data;
    setRecordsviewLayout(newLayout);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchCurrentSmData();
      } catch (error) {
        handleError(error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!recordsviewLayout) return;
  const renderSidebarContent = () => {
    switch (activeTab) {
      case "Filters":
        return <MobileFilters />;
      case "Pre Filters":
        return (
          <PreFilter
            preFilters={recordsviewLayout.pre_filters}
            setPreFilters={(data) => callbackFunctionOfOwnerAnePreFilter("pre_filters", data)}
            ownerPreFilters={recordsviewLayout.owner_pre_filters}
            setOwnerPreFilters={(data) => callbackFunctionOfOwnerAnePreFilter("owner_pre_filters", data)}
            table_id={applicationBlockData.config.layout.table_id}
            prefiltersJoinedBy={recordsviewLayout?.prefilters_joined_by}
            setPrefiltersJoinedBy={(data) => callbackFunctionOfOwnerAnePreFilter("prefilters_joined_by", data)}
            type="recordview"
          />
        );
      case "Tiles":
        return (
          <BlockTiles
            tiles={recordsviewLayout.tiles}
            setTiles={settingTiles}
            table_id={applicationBlockData.config.layout.table_id}
            allTableColumns={tableRef.current}
          />
        );
      case "Actions":
        return (
          <EditActions
            actions={recordsviewLayout.multi_select_custom_actions}
            setActions={settingActions}
            device={applicationBlockData.device}
            tableId={applicationBlockData.config.layout.table_id}
            elements={[applicationBlockData]}
            tableType={applicationBlockData?.table_type || "statemachine"}
          />
        );
      case "General":
        return <EditGeneralData tableRef={tableRef} />;
      case "Style":
        return <EditRvStyles recordsviewLayout={recordsviewLayout} setRecordsviewLayout={setRecordsviewLayout} />;
      default:
        return null;
    }
  };

  const tabs = [
    { name: "Filters", count: recordsviewLayout?.onscreen_filters?.length || 0 },
    { name: "Pre Filters", count: recordsviewLayout?.pre_filters?.length || 0 },
    { name: "Tiles", count: recordsviewLayout?.tiles?.length || 0 },
    { name: "Actions", count: recordsviewLayout?.multi_select_custom_actions?.length || 0 },
    { name: "General" },
    { name: "Style" }
  ];

  const handleDragStart = (e, name, id, type) => {
    setDragFromOutside(true);
    e.dataTransfer.setData("id", id);
    e.dataTransfer.setData("type", type);
    e.dataTransfer.setData("name", name);
  };
  return (
    <>
      <div className="detailsView_outer_body">
        <div className="detailsView_main_section">
          <MobileRVPageActionsHandler />
          <div className="mobile_recordview_main_page">
            <div className="page_tab_container_wrap ">
              <div className="page_tab_container float_btn"></div>
              <div className="d_flex gap_2 align_center">
                {tabs.map(({ name, count }) => (
                  <div key={name} className="d_flex gap_2 align_center">
                    <div className="d_flex gap_1 justify_center align_center">
                      <label className="builder_label">{name}</label>
                      {count > 0 && (
                        <span
                          className="d_flex gap_1 justify_center align_center"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "100%",
                            backgroundColor: "var(--builder-primary)",
                            border: "1px solid var(--builder-primary)",
                            color: "var(--builder-active)"
                          }}
                        >
                          {count}
                        </span>
                      )}
                    </div>
                    <label className="builder_toggle_label" style={{ width: "2.8em", height: "1.6em" }}>
                      <input
                        type="checkbox"
                        onClick={() => {
                          setActiveTab(activeTab === name ? null : name);
                        }}
                        checked={activeTab === name}
                        readOnly
                      />
                      <span className="builder_toggle_slider" style={{ height: "1.6em", width: "2.8em" }}>
                        <span className="slider_circle" style={{ height: "calc(1.2em)", width: "calc(1.2em)" }}></span>
                      </span>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="d_flex">
              <div className="detailsView_main_section w_100">
                <div className="desktop_draggable_field_outer">
                  <div
                    id="droppableContainerWidth"
                    className={"screen_header_draggable_outer position-screen-mobile-preview-outer rv_screen_grid"}
                    style={{
                      width: "50%"
                    }}
                  >
                    <DetailviewLayoutEditor
                      dragFromOutside={dragFromOutside}
                      setDragFromOutside={setDragFromOutside}
                      tableRef={tableRef}
                      device={applicationBlockData.device}
                      tableID={recordsviewLayout.table_id || ""}
                      tableType={applicationBlockData.table_type}
                      activityID={recordsviewLayout.activity_id || ""}
                      elements={[applicationBlockData]}
                      variables={[]}
                    />
                  </div>
                </div>
              </div>
              <DetailsviewElementsBar handleDragStart={handleDragStart} />
            </div>
          </div>
        </div>

        {activeTab && (
          <BuilderRightSideBar
            isOpen={true}
            onClose={() => setActiveTab(null)}
            heading={`Edit ${activeTab}`}
            size="large"
          >
            {renderSidebarContent()}
          </BuilderRightSideBar>
        )}
      </div>
    </>
  );
};
export default MobileRenderer;
